import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      name: 'Authority |||| Authorities',
      arrayInputLabel: 'Authorities',
    }
  }
}